import { Layout } from "antd";
const { Footer } = Layout;

export default function AppFooter() {
  return (
    <Footer
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 0",

        // 🌙 Dark theme
        background: "#001529",            // AntD dark base
        color: "rgba(255,255,255,0.85)",

        borderTop: "1px solid rgba(255,255,255,0.15)",
        fontSize: "15px",
        letterSpacing: "0.3px",
      }}
    >
      © {new Date().getFullYear()} Hall 11 Website
    </Footer>
  );
}
